// extracted by mini-css-extract-plugin
module.exports = {"tooltip-title":"tooltip-wrapper_tooltip-title__aRWqf","tooltip-text":"tooltip-wrapper_tooltip-text__8Qwj_","tooltip-cta":"tooltip-wrapper_tooltip-cta__8BBQh"};